export default function IconVideoFile() {
  return (
    <svg height="100%" viewBox="0 0 24 24" width="100%">
      <g fill="#000000">
        <path d="M21.536 5.592l-5.488 4.427-.048.076V7.048C16 5.364 14.567 4 12.8 4H3.2C1.433 4 0 5.364 0 7.048v9.904C0 18.636 1.433 20 3.2 20h9.6c1.767 0 3.2-1.364 3.2-3.048v-3.047l.056.053 5.48 4.427C22.872 19.49 24 19.01 24 17.333V6.667c0-1.677-1.128-2.157-2.464-1.075z" />
      </g>
    </svg>
  )
}
